import React from "react";
import MaterialTable from "material-table";
import { translator } from "../../utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import { editAppointment } from "../../utils/fetcher";
import Avatar from "@material-ui/core/Avatar";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import DateRangeIcon from "@material-ui/icons/DateRange";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import Tooltip from "@material-ui/core/Tooltip";
import Download from "./Download";

function MyHistory() {
  const dispatch = useDispatch();
  const listAppointments = useSelector(state =>
    state.patientArea.history ? state.patientArea.history : []
  );

  const editAppointmentFunc = (
    doctorId,
    professionId,
    placeId,
    motifId,
    url,
    appointmentId
  ) =>
    dispatch(
      editAppointment(
        doctorId,
        professionId,
        placeId,
        motifId,
        url,
        appointmentId
      )
    );

  const state = {
    columns: [
      { title: `contenu`, field: "content", filtering: false },
      { title: `Nom`, field: "lastName", filtering: false },
      { title: `Prénom`, field: "firstName" },
      { title: `Nom du praticien`, field: "infoDoctor" },
      { title: `Motif`, field: "motif" },
      { title: `Date`, field: "date", filtering: false }
    ]
  };

  const buildHtml = () => {
    let newData = [];
    if (listAppointments) {
      newData = listAppointments.map(item => {
        const html = (
          <div className="wrap-item history">
            <Avatar className="avatar-orange margin-auto avatar-big">
              {item.lastName.charAt(0)}
              {item.firstName.charAt(0)}
            </Avatar>
            <div className="infos">
              <div className="name">
                {item.isAnon && <strong>{item.motif}</strong>}
                {!item.isAnon && (
                  <div>
                    <strong>{item.infoDoctor}</strong> - ({item.motif})
                  </div>
                )}
              </div>
              {item.isCancelled && (
                <ul
                  className="un-styled infos-user"
                  style={item.isCancelled ? { color: "#D9736B" } : {}}
                >
                  Annulé
                </ul>
              )}
              <ul className="un-styled infos-user">
                <li>
                  <PermIdentityIcon />
                  {item.firstName} {item.lastName}
                </li>
                <li>
                  <DateRangeIcon />
                  {item.date}
                </li>
                <li>
                  <QueryBuilderIcon />
                  {item.Hour}
                </li>
              </ul>
            </div>
            <div className="settings">
              {item.isUploadFile && (
                <Download id={item.appointmentId} doctorId={item.doctorId} />
              )}
              {item.isReusable && (
                <Tooltip title={translator()._("W_PRENDRE_MEME_RENDEZ_VOUS")}>
                  <button
                    className="no-bg"
                    onClick={() =>
                      editAppointmentFunc(
                        item.doctorId,
                        item.professionId,
                        item.placeId,
                        item.motifId,
                        item.moveUrl,
                        item.appointmentId
                      )
                    }
                  >
                    <img
                      src="images/appointment.svg"
                      alt=""
                      width="24"
                      height="24"
                    />
                  </button>
                </Tooltip>
              )}
            </div>
          </div>
        );
        return {
          content: html,
          appointmentId: item.appointmentId,
          lastName: item.lastName,
          firstName: item.firstName,
          infoDoctor: item.infoDoctor,
          motif: item.motif,
          date: item.date,
          Hour: item.Hour,
          doctorId: item.doctorId,
          professionId: item.professionId,
          placeId: item.placeId,
          motifId: item.motifId,
          isCancelled: item.isCancelled
        };
      });
    }
    return newData;
  };

  return (
    <div className="wrap-custom-table">
      <h1 className="title-page">{translator()._("CP_MENU_HISTORIQUE")}</h1>
      <div className="wrap-inner-table filter-disabled">
        <MaterialTable
          title=""
          columns={state.columns}
          data={buildHtml()}
          showFirstLastPageButtons={false}
          options={{
            actionsColumnIndex: -1,
            maxBodyHeight: 350,
            pageSize: 3,
            rowStyle: rowData => ({
              border: rowData.isCancelled ? "5px solid #D9736B" : ""
            })
          }}
          localization={{
            pagination: {
              labelDisplayedRows: "{from}-{to} of {count}",
              previousTooltip: `${translator()._("W_PREVIOUS_PAGE")}`,
              nextTooltip: `${translator()._("W_NEXT_PAGE")}`,
              lastTooltip: `${translator()._("W_LAST_PAGE")}`,
              firstTooltip: `${translator()._("W_FIRST_PAGE")}`
            },
            toolbar: {
              nRowsSelected: "{0} row(s) selected",
              searchPlaceholder: `${translator()._("CP_SEARCH")}`
            },
            header: {
              actions: "Actions"
            },
            body: {
              deleteTooltip: `${translator()._("W_SUPPRIMER")}`,
              emptyDataSourceMessage: `${translator()._("W_NO_HISTORY")}`,
              filterRow: {
                filterTooltip: "Filter"
              },
              editRow: {
                deleteText: `${translator()._(
                  "W_SOUHAITEZ_VOUS_VRAIMENT_SUPPRIMER_RENDEZ_VOUS"
                )}`,
                cancelTooltip: `${translator()._("W_ANNULER")}`,
                saveTooltip: `${translator()._("W_STEP_BOUTON_CONTINUER")}`
              }
            }
          }}
        />
      </div>
    </div>
  );
}

export default MyHistory;
